/**
 * Types of folderable app UIs.
 */
export enum FolderableAppType {
    // Folderable items can be selected through a modal
    MODAL = 'modal',
    // Folderable items are rendered as a list
    LIST_PAGE = 'list_page',
}
